import { get } from "lodash";

// Beneficiaries Selectors
export const getBeneficiariesData = (state) => get(state.beneficiaries, "beneficiariesData");
export const getBeneficiariesIsFetching = (state) => get(state.beneficiaries, "isFetching");
export const getBeneficiariesIsError = (state) => get(state.beneficiaries, "isError");

// Donations Selectors
export const getDonationsData = (state) => get(state.donations, "donationsData");
export const getDonationsIsFetching = (state) => get(state.donations, "isFetching");
export const getDonationsIsError = (state) => get(state.donations, "isError");

// Events Selectors
export const getEventsData = (state) => get(state.events, "eventsData");
export const getEventsIsFetching = (state) => get(state.events, "isFetching");
export const getEventsIsError = (state) => get(state.events, "isError");

// Login Selectors
export const getLoginData = (state) => get(state.login, "loginData.status");
export const getLoginIsFetching = (state) => get(state.login, "isFetching");
export const getLoginIsError = (state) => get(state.login, "isError");

// Notifications Selectors
export const getNewTeamNotificationStatus = (state) => get(state.notifications, "status");
export const getNewTeamNotificationName = (state) => get(state.notifications, "name");

// Donation Notification Selectors
export const getDonationNotificationStatus = (state) => get(state.donationNotification, "status");
export const getDonationNotificationTeamName = (state) => get(state.donationNotification, "name");

// Pinnacle Message Selector
export const getPinnacleMessageOpenStatus = (state) => get(state.pinnacleMessage, "modalOpen");

// Processing Fee Selector
export const getProcessingFeeData = (state) => get(state.processingFee, "processingFeeData.percentage");
export const getProcessingFeeIsFetching = (state) => get(state.processingFee, "isFetching");
export const getProcessingFeeIsError = (state) => get(state.processingFee, "isError");

// Processing Fee Vendor Selector
export const getProcessingFeeVendorData = (state) => get(state.processingFeeVendor, "processingFeeVendorData.percentage");
export const getProcessingFeeVendorIsFetching = (state) => get(state.processingFeeVendor, "isFetching");
export const getProcessingFeeVendorIsError = (state) => get(state.processingFeeVendor, "isError");

// Teams Selectors
export const getTeamsData = (state) => get(state.teams, "teamsData");
export const getTeamsIsFetching = (state) => get(state.teams, "isFetching");
export const getTeamsIsError = (state) => get(state.teams, "isError");
